<rwidget-wallet-top-up-modal
    #walletTopUpModal
    (amountSelected)="handleAmountSelected($event)"></rwidget-wallet-top-up-modal>

<div class="mt-4 bg-white p-4 [box-shadow:0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_0px_4px_-1px_rgba(0,0,0,0.06)]">
    <h5 class="text-xs font-bold uppercase tracking-wide text-ironside_grey dark:text-contrast-yellow">
        {{ 'AMOUNT_OF_MONEY' | translate }}
    </h5>

    <ul class="mt-2 grid grid-cols-3 gap-4">
        <li *ngFor="let p of filteredWalletProducts$ | async">
            <button
                class="w-full rounded-lg border-2 border-solid border-[#F2F2F2] py-7 text-[1.375rem] font-bold leading-5 [box-shadow:0px_1px_2px_rgba(0,0,0,0.3)] dark:border-contrast-yellow dark:text-contrast-yellow"
                [ngClass]="{
                    'border-primary text-black': selectedProduct && selectedProduct?.product_id === p.product_id,
                    'text-black': !selectedProduct,
                    'text-old_silver': selectedProduct && selectedProduct?.product_id !== p.product_id,
                    'dark:opacity-50':
                        !selectedProduct || (selectedProduct && selectedProduct?.product_id !== p.product_id)
                }"
                [attr.aria-label]="'SELECT_AMOUNT' | translate"
                (click)="selectProduct(p)">
                <ng-container *ngIf="env.APP_NAME === 'gotland'; else originalCurrencyFormat">
                    {{ (p | translateObjectField: 'short_name' : locale).split(' ')[0] }} {{ currencySymbol }}
                </ng-container>
                <ng-template #originalCurrencyFormat>
                    {{ p | translateObjectField: 'short_name' : locale }}
                </ng-template>
            </button>
        </li>

        <li *ngIf="manualPriceProduct$ | async as manualProduct">
            <button
                class="gl-light:text-secondary w-full rounded-lg border-2 border-solid border-[#F2F2F2] px-1 py-7 leading-5 [box-shadow:0px_1px_2px_rgba(0,0,0,0.3)] dark:border-contrast-yellow dark:bg-contrast-yellow dark:text-contrast-black"
                [ngClass]="{
                    'border-primary text-[1.375rem] font-bold text-black': selectedAmount,
                    'bg-grey-white_smoke text-base font-bold text-primary': !selectedAmount
                }"
                [attr.aria-label]="'SELECT_CUSTOM_AMOUNT' | translate"
                (click)="selectCustomProduct()">
                {{ selectedAmount ? selectedAmount + ' ' + currencySymbol : ('SELECT_CUSTOM_AMOUNT' | translate) }}
            </button>
        </li>
    </ul>
</div>
